<script setup>

defineProps({
    diary: Object
})
</script>

<script>
export default {
    data(){
        return {

        }
    },
    mounted(){

    }
}
</script>

<template>
    <a :href="route('neighbourhood-diary.show', {diary: diary.slug})" class="text-decoration-none">
        <div class="what-we-do-card">
            <div class="what-we-do-card-top">
                <figure class="card-img">
                    <img :src="asset(diary.image)" onerror="this.src='/images/homepage/what-we-do/luxury-residential.jpg'">
                </figure>
            </div>
                <div class="what-we-do-card-bottom">
                <div class="bottom-wrapper">
                    <p>{{ diary.title }}</p>
                    <a :href="route('neighbourhood-diary.show', {diary: diary.slug})">Read More
                        <span>
                            <svg width="852pt" height="158pt" viewBox="0 0 852 158"
                                version="1.1" xmlns="http://www.w3.org/2000/svg">
                                <g id="#ffffffff">
                                </g>
                                <g id="#1e1e1eff">
                                    <path fill="#1e1e1e" opacity="1.00"
                                        d=" M 722.48 10.03 C 762.39 33.09 802.33 56.10 842.23 79.19 C 802.31 102.23 762.40 125.29 722.47 148.33 C 722.47 102.23 722.47 56.13 722.48 10.03 Z" />
                                    <path fill="#1e1e1e" opacity="1.00"
                                        d=" M 9.65 75.80 C 216.26 75.80 422.86 75.79 629.47 75.80 C 629.47 80.98 629.47 86.15 629.47 91.33 C 422.86 91.33 216.25 91.34 9.65 91.32 C 9.65 86.15 9.65 80.97 9.65 75.80 Z" />
                                </g>
                            </svg>
                        </span>
                    </a>
                </div>
            </div>
        </div>
    </a>
</template>